import { IResponse, consumer } from '@bemap/utils';

export interface CampaignLinkDTO {
  id: number;
  code: string;
  label: string | null;
  is_active: boolean;
  team_id: number;
  owner_user_id: number;
  sales_funnel_id?: number | null;
}

export const listCampaignLinks = async (): Promise<IResponse> => {
  return consumer('GET', `/campaign-links`);
};

export const createCampaignLink = async (payload: { label?: string | null; sales_funnel_id?: number | null }): Promise<IResponse> => {
  return consumer('POST', `/campaign-links`, payload);
};

export const updateCampaignLink = async (
  id: number,
  payload: Partial<Pick<CampaignLinkDTO, 'label' | 'is_active' | 'sales_funnel_id'>>,
): Promise<IResponse> => {
  return consumer('PATCH', `/campaign-links/${id}`, payload);
};

export const deleteCampaignLink = async (id: number): Promise<IResponse> => {
  return consumer('DELETE', `/campaign-links/${id}`);
};

export default {
  listCampaignLinks,
  createCampaignLink,
  updateCampaignLink,
  deleteCampaignLink,
};


